(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/footer-text.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/footer-text.js');

'use strict';

const FooterText = _ref => {
  let {
    isLogin = true,
    isBankId = true
  } = _ref;
  const {
    isTestEnvironment
  } = ReactRedux.useSelector(state => state.playerloginreact);
  const {
    TestPanel
  } = svs.playerLogin.sharedComponents;
  return React.createElement("div", {
    className: "margin-xs-top-1"
  }, !isLogin && isBankId && React.createElement("p", null, "Genom att nyttja BankID s\xE4kerst\xE4ller vi din identitet, kontrollerar att du \xE4r \xF6ver 18 \xE5r och folkbokf\xF6rd i Sverige. F\xF6r att efterleva svensk lag kommer vi att h\xE4mta och spara dina namnuppgifter. Du kan alltid kontrollera dina kunduppgifter under Min Profil."), !isLogin && !isBankId && React.createElement("p", null, "Genom att nyttja Freja eID s\xE4kerst\xE4ller vi din identitet, kontrollerar att du \xE4r \xF6ver 18 \xE5r och folkbokf\xF6rd i Sverige. F\xF6r att efterleva svensk lag kommer vi att h\xE4mta och spara dina namnuppgifter. Du kan alltid kontrollera dina kunduppgifter under Min Profil."), React.createElement("p", null, "Spel f\xF6r dig \xF6ver 18 \xE5r", React.createElement("br", null), "St\xF6dlinjen:", ' ', React.createElement("span", {
    className: "login-react-hover"
  }, React.createElement("a", {
    className: "f-inverted u-text-decoration-underline",
    href: "tel:020-819100"
  }, "020 81 91 00"))), isTestEnvironment && React.createElement(TestPanel, null));
};
svs.playerLogin.sharedComponents.FooterText = FooterText;

 })(window);